// Import redux/toolkit
import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/AuthSlice";
import businessReducer from "./slices/BusinessSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    business: businessReducer,
  },
});

export default store;
